const theme = {
    colors: {
        primary: '#c38bd2'
    }
}

export default theme;